/**
 * @generated SignedSource<<8bf1d80768c96a84c6340597f6fea102>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Avatar_groupActor$data = {
  readonly employee: {
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"Avatar_employee">;
  } | null;
  readonly " $fragmentType": "Avatar_groupActor";
};
export type Avatar_groupActor$key = {
  readonly " $data"?: Avatar_groupActor$data;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_groupActor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Avatar_groupActor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Avatar_employee"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GroupActor",
  "abstractKey": null
};

(node as any).hash = "15297bad28820d621e24cfd4825da55e";

export default node;
